import { FEET_IN_ONE_METER } from '../../constants/units';
import round from '../round';

export default function feetToMetres(feet: number): number {
  return round(feet / FEET_IN_ONE_METER, 6);
}
